import * as Constant from '../constants/actionTypes';

const initialState = {
  locale: Constant.LABEL_EN,
  isfirstTimeUser: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Constant.LANGUAGE_CHANGED:
      // Used to update the primary lang attribute (html) for the page in web, to resolve accessibility (Structure) issue.
      document.documentElement.lang = action.locale;
      return {
        ...state,
        locale: action.locale,
        isfirstTimeUser: true,
      };

    // case types.RESET:
    //   return initialState;

    default:
      return state;
  }
};
